<template>
  <v-card class="elevation-1 pa-3 login-card">
    <v-card-text>
      <div class="layout column align-center">
        <h1 class="flex my-4 primary--text">Admin Login</h1>
      </div>
      <v-form>
        <v-text-field append-icon="person" name="email" label="Email" type="text" v-model="email"></v-text-field>
        <v-text-field append-icon="lock" name="password" label="Password" type="password" v-model="password"></v-text-field>
      </v-form>
    </v-card-text>
    <div class="login-btn">
      <v-spacer></v-spacer>
      <v-btn block color="primary" @click="Login">Login</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  data(){
    return {

      email      : "",
      password   : '',

    }
  },
  methods: {

    Login(){

      this.$eventHub.$emit("LOADING",'true')
      this.$http.post(`${this.$store.getters.GetProductionUrl}/login/login`,{ 'email' : this.email , password : this.password })
                    .then(response =>{
                      
                      if(response['data']['status'] == true){
                        
                        this.$eventHub.$emit("LOADING",'true')
                        var d = new Date()
                        d.setTime(d.getTime() + (7*24*60*60*1000));
                        document.cookie = `access_token=${response['data']['response'].Token};expires=${d.toUTCString()}`
                        this.$http.defaults.headers.common['Authorization'] = response['data']['response'].Token
                        this.$router.go()
                      
                      }else{

                          this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Logging In","Color":"red","Close": false });
                      }
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
  },
  mounted(){

    this.$eventHub.$emit("LOADING",'false')
  }
}
</script>
<style scoped lang="css"></style>
